// Listings Only
const selectedFilterClass = 'v2-text-primary-500 v2-border-current';
const unselectedFilterClass = 'v2-text-grey-2';

function setNavArrowPositions(listingsContainer, nextArrows, prevArrows) {
  const cards = $(listingsContainer).find('.carousel-card-image');
  const firstCard = cards.get(0);
  const arrowHeight = $(nextArrows).outerHeight();

  const topOffset = $(listingsContainer).position().top;
  const cardHeight = $(firstCard).height();
  const arrowYOffset = cardHeight / 2 + topOffset - arrowHeight / 2;

  const leftArrowXOffset =
    $(listingsContainer).position().left - arrowHeight / 2;
  const rightArrowXOffset =
    $(listingsContainer).position().left +
    $(listingsContainer).width() -
    arrowHeight / 2;

  prevArrows.css({ top: arrowYOffset, left: leftArrowXOffset });
  nextArrows.css({ top: arrowYOffset, left: rightArrowXOffset });
}

function toggleArrows(slider, nextArrows, prevArrows, listingsLength) {
  if (listingsLength <= 3) {
    prevArrows.css({ visibility: 'hidden' });
    nextArrows.css({ visibility: 'hidden' });
  } else {
    prevArrows.css({ visibility: 'visible' });
    nextArrows.css({ visibility: 'visible' });
  }
}

// Listings Only
const handleFilterSelection = (event) => {
  const target = $(event.currentTarget);
  const filterId = target.attr('data-filter');
  const listingsComponent = target.closest('.listings-component');
  const slider = listingsComponent.find('.carousel-slider');

  slider.slick('slickUnfilter');
  slider.slick('slickFilter', `.${filterId}`);

  const listingsFilters = listingsComponent
    .find('#listings-filters')
    .find('button');

  listingsFilters.each(function (idx, element) {
    $(element).addClass(unselectedFilterClass).removeClass(selectedFilterClass);
  });

  target.removeClass(unselectedFilterClass).addClass(selectedFilterClass);

  const listingsLength = slider.find(`#listing-card.${filterId}`).length;
  toggleArrows(
    slider,
    event.data.nextArrows,
    event.data.prevArrows,
    listingsLength
  );
};

// Listings Only
function initialiseListingFilters(slider, nextArrows, prevArrows) {
  /*
    Initially filter by first available listing type as determined by the
    filter buttons displayed on the block
  */

  const listingsFilters = slider
    .closest('.listings-component')
    .find('#listings-filters')
    .find('button');

  // the defaultFilter will only exist for versatile and minimal since classic doesn't use filters
  const defaultFilter = listingsFilters.attr('data-filter');

  if (defaultFilter) {
    slider.slick('slickFilter', `.${defaultFilter}`);

    listingsFilters
      .first()
      .removeClass(unselectedFilterClass)
      .addClass(selectedFilterClass);

    $('.listings-filter').on(
      'click',
      {
        prevArrows,
        nextArrows
      },
      handleFilterSelection
    );

    const listingsLength = slider.find(`#listing-card.${defaultFilter}`).length;
    toggleArrows(slider, nextArrows, prevArrows, listingsLength);
  } else {
    // Classic slider doesn't use filters
    const listingsLength = slider.find('#listing-card.carousel-card').length;
    toggleArrows(slider, nextArrows, prevArrows, listingsLength);
  }
}

$(document).ready(function () {
  // Get all carousel sliders - there could be multiple blocks using the carousel
  const sliders = $('.carousel-slider');

  sliders.each(function (idx, element) {
    const slider = $(element);
    const sliderType = slider.data('role');
    const theme = slider.data('theme');

    // Initialise slick on each slider
    slider.slick({
      infinite: true,
      slidesToShow: sliderType === 'listings' ? 3 : 4,
      speed: 200,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            slidesToShow: 1,
            swipeToSlide: true,
            centerMode: theme === 'minimal'
          }
        },
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1280,
          settings: {
            infinite: true,
            slidesToShow: 3
          }
        }
      ]
    });

    const nextArrows = slider
      .closest('.carousel-wrapper')
      .find('.carousel-slider-next-btn');
    const prevArrows = slider
      .closest('.carousel-wrapper')
      .find('.carousel-slider-prev-btn');

    setNavArrowPositions(slider, nextArrows, prevArrows);

    $(window).on('resize', () =>
      setNavArrowPositions(slider, nextArrows, prevArrows)
    );

    nextArrows.on('click', (event) => {
      const s = $(event.currentTarget).attr('data-id');
      $(`.carousel-slider-${s}`).slick('slickNext');
    });

    prevArrows.on('click', (event) => {
      const s = $(event.currentTarget).attr('data-id');
      $(`.carousel-slider-${s}`).slick('slickPrev');
    });

    // Listings Only
    if (sliderType === 'listings') {
      initialiseListingFilters(slider, nextArrows, prevArrows);
    }
  });
});
